module.exports = __webpack_public_path__ + "img/yhzg.7f807e5d.svg";